import { useCallback, useEffect, useState } from "react";
import { parseHash, rutaAHash, type Ruta } from "./ruta.ts";

// La parte pura (tipos, hash y su lectura) vive en ruta.ts, sin React, para probarla con Deno.
export { parseHash, rutaAHash, type Ruta } from "./ruta.ts";

export function useRuta(): [Ruta, (r: Ruta) => void] {
  const [ruta, setRutaState] = useState<Ruta>(() => parseHash(window.location.hash));

  useEffect(() => {
    const normalizada = rutaAHash(parseHash(window.location.hash));
    if (window.location.hash !== normalizada) {
      window.history.replaceState(null, "", normalizada);
    }
    const sync = () => {
      setRutaState(parseHash(window.location.hash));
    };
    window.addEventListener("hashchange", sync);
    sync();
    return () => {
      window.removeEventListener("hashchange", sync);
    };
  }, []);

  const setRuta = useCallback((r: Ruta) => {
    const nextHash = rutaAHash(r);
    if (window.location.hash === nextHash) {
      setRutaState(r);
      return;
    }
    window.location.hash = nextHash;
  }, []);

  return [ruta, setRuta];
}
